import BaseException from './base_exception'

class Missing extends BaseException {
  constructor(propertyName) {
    super('hs.errors.missing', { propertyName })
  }
}

export default Missing
